import Http from "./http";

export const updateProductAPI = (data) => {
  return Http.post("admin/product/updateProduct",data);
};
